import React, { Component } from 'react';
import { connect } from "react-redux";
import moment from 'moment';
import axios from "axios";
import { debounce } from "lodash";
import i18n from'i18next';
import { Trans } from 'react-i18next';
import {XIconGrey, Trash} from '../../../Common/Buttons/Icons';
import DatePicker from '../../../Common/DatePicker';
import { uploadS3 } from '../../../../Helpers/uploadFile';
import { constants } from '../../../../Helpers/Constants';
import uuid from "uuidv4";
import { LoadingIcon, InLineLoading } from '../../../Common/Loading_Icon';
import _ from 'lodash';
import { VehicleResultCard, SelectedVehicleCard } from '../../../Common/DesignSystem/VehicleResultCard';
import {DropdownItem, Input} from '../../../Common/DesignSystem/Input';
import colours from '../../../Common/DesignSystem/Colours';
import Icon from '../../../Common/DesignSystem/Icons/Icon';
import Button from '../../../Common/DesignSystem/Button';
import { CaptionLarge, CaptionSmall, Heading6, InputLabel, P2, P2Bold, P3, P3Bold } from '../../../Common/DesignSystem/Text';
import Toggle from 'react-toggle';
import BookingResultCard from '../../../Common/DesignSystem/BookingResultCard';
import Stars from '../../../Common/Stars';
import ReactTooltip from 'react-tooltip';

class ExpenseOverlay extends Component {

    constructor(props) {
        super(props);
        this.dropRef = React.createRef();
        this.fileInputRef = React.createRef();
        this.dateRef = React.createRef();
        this.searchVehicleRef = React.createRef();
        this.searchBookingsRef = React.createRef();

        this.state = {
            loading: false,
            vehicleSearching: false,
            noResults: false,
            invoices: [],
            province_options: [],
            category_options: [],
            dragging: false,
            hover: '-1',
            edited: false,
            errors: {
                vehicleError: '',
                dateError: '',
                merchantError: '',
                lineItemsError: '',
                regionError: '',
                pdfError: ''
            },
            vehicle: this.props.vehicle_details ? this.props.vehicle_details.vehicle.Year + " " + this.props.vehicle_details.vehicle.Make + " " + this.props.vehicle_details.vehicle.Model + " " + this.props.vehicle_details.vehicle.Trim : '',
            selectedVehicle: null,
            vehicle_details: null,
            vehicle_bookings: [],
            vin: this.props.vehicle_details ? this.props.vehicle_details?.vehicle.VIN : '',
            sh_id: this.props.vehicle_details ? this.props.vehicle_details.vehicle.SH_ID : '',
            v_id: this.props.vehicle_details ? this.props.vehicle_details.vehicle.V_ID : this.props.v_id ? this.props.v_id : '',
            content: {
                date: '',
                merchant: '',
                totalcost: '',
                netcost: '',
                tax: '',
                region: '',
                description: ''
            },
            line_items: [],
            searchVehicleResults: [],
            showVehicleSearchResults: false,
            link_booking: false,
            link_booking_search: '',
            bookingSearchResults: [],
            showBookingSearchResults: false,
            link_user: false,
            windowWidth: window.innerWidth
        }

        this.handleDrag = this.handleDrag.bind(this);
        this.handleDragIn = this.handleDragIn.bind(this);
        this.handleDragOut = this.handleDragOut.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.removePdf = this.removePdf.bind(this);
        this.onUploadSuccess = this.onUploadSuccess.bind(this);
        this.onUploadFail = this.onUploadFail.bind(this);
        this.submitExpense = debounce(this.submitExpense.bind(this), 500);
        this.updateExpense = debounce(this.updateExpense.bind(this), 500);
        this.getAttachmentURLs = this.getAttachmentURLs.bind(this);
        this.prepopulateForm = this.prepopulateForm.bind(this);
        this.prepareForm = this.prepareForm.bind(this);
        this.searchVehicles = debounce(this.searchVehicles, 500);
        this.searchBookings = this.searchBookings.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.selectVehicleFromSearch = this.selectVehicleFromSearch.bind(this);
        this.selectBookingFromSearch = this.selectBookingFromSearch.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.sumStr = this.sumStr.bind(this);
        this.getTotal = this.getTotal.bind(this);
        this.setLineItemValue = this.setLineItemValue.bind(this);
        this.addEmptyLineItem = this.addEmptyLineItem.bind(this);
        this.getCategoryNameByID = this.getCategoryNameByID.bind(this);
        this.openAttachment = this.openAttachment.bind(this);
        this.getProfileName = this.getProfileName.bind(this);
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);

        let div = this.dropRef.current;
        this.dragCounter = 0;
        div.addEventListener('dragenter', this.handleDragIn);
        div.addEventListener('dragleave', this.handleDragOut);
        div.addEventListener('dragover', this.handleDrag);
        div.addEventListener('drop', this.handleDrop);
        
        this.setState({loading: true});

        if (this.props.mode == constants.add_expense_mode.add) {
            this.addEmptyLineItem();
        }
        if (this.props.vehicle_details) {
            this.setState({
                selectedVehicle: this.props.vehicle_details.vehicle, 
                vehicle_bookings: [
                    ...this.props.vehicle_details.bookings.cancelled,
                    ...this.props.vehicle_details.bookings.current,
                    ...this.props.vehicle_details.bookings.past,
                    ...this.props.vehicle_details.bookings.pending,
                    ...this.props.vehicle_details.bookings.pending_return,
                    ...this.props.vehicle_details.bookings.upcomming,
                ]
            });
            this.prepareForm(this.props.vehicle_details.vehicle.V_ID);
        } else if (this.props.v_id) {
            this.prepareForm(this.props.v_id);
        }
        if (this.props.expense_id) {
            this.prepopulateForm();
        } else {
            this.setState({loading: false})
        }

    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);

        let div = this.dropRef.current;
        div.removeEventListener('dragenter', this.handleDragIn);
        div.removeEventListener('dragleave', this.handleDragOut);
        div.removeEventListener('dragover', this.handleDrag);
        div.removeEventListener('drop', this.handleDrop);
    }

    handleResize () {
        this.setState({windowWidth: window.innerWidth});
    }

    onUploadSuccess(filename) {
        let uploadedFiles = this.state.invoices;

        _.each(uploadedFiles, function(file, key) {
            if(filename.indexOf(file.UUID) !== -1)
            {
                uploadedFiles[key]["URL"] = filename;
            }
        });

        this.setState({invoices: uploadedFiles});
    }

    onUploadFail(error, file) {
        //display error
        let invoices = this.state.invoices;

        if (file && file.name) {

            invoices.map((invoice, index) => {
                if ((invoice.Name + "." + invoice.Extension) == file.name) {
                    invoice['error'] = "Sorry, we weren't able to upload this attachment: \n" + error;
                }
            })
        }
        this.setState({invoices: invoices});
    }

    validateFields() {
        let newErrors = this.state.errors;
        let validated = true;
        //ensure that all required fields are filled out correctly
        if (this.state.vin.length !== 17) {
            newErrors.vehicleError = "Invalid vehicle.";
            validated=false;
        }

        if (this.state.content.date.length < 1) {
            newErrors.dateError = "Required.";
            validated=false;
        }

        if (this.state.content.merchant.length < 1) {
            newErrors.merchantError = "Required."
            validated=false;
        }
        
        if (this.state.line_items.length < 1) {
            newErrors.lineItemsError = "Minimum one entry required.";
            validated=false;
        }

        if (this.state.content.region == null || this.state.content.region.length < 1) {
            newErrors.regionError = "Required.";
            validated=false;
        }
        
        return validated;
    }

    removePdf (index) {
        let newArr = this.state.invoices;
        newArr.splice(index, 1);

        this.setState({invoices: newArr, edited: true});
    }

    handleDrag (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    
    handleDragIn (e) {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter++;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            this.setState({dragging: true});
          }
    }
    handleDragOut (e) {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter > 0) return;
        this.setState({dragging: false});
    }

    handleDrop (e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({dragging: false});
        let tempArray = [];

        if (this.state.selectedVehicle) {
            Array.from(e.dataTransfer.files).forEach(file => {
    
                let originalname = file.name.substring(0, file.name.lastIndexOf('.'));
                let extension = file.name.substring((file.name.lastIndexOf('.') + 1));
                
                if (extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "pdf") {
                    let unique_id = uuid();
                    let s3filename = "expense_attachment_" + this.state.vin + "_" + originalname;
                    uploadS3(file, s3filename, extension, '/expense-attachments', unique_id, this.onUploadSuccess, this.onUploadFail);
                    tempArray.push({Name: originalname, URL: "", Extension: extension, UUID: unique_id});
                }
            });
    
            if (this.state.vin !== '' && tempArray && (tempArray.length > 0) && (tempArray.length + this.state.invoices.length) <= 5) {
                var joined = this.state.invoices.concat(tempArray);
                this.setState({invoices: joined});
                e.dataTransfer.clearData();
                this.dragCounter = 0;
            } else if ((tempArray.length + this.state.invoices.length) > 5) {
                let errors = this.state.errors;
                errors['pdfError'] = 'Sorry, a maximum of 5 files can be uploaded per expense.';
                this.setState({errors: errors});
                e.dataTransfer.clearData();
                this.dragCounter = 0;
            }
        }
    }

    handleUpload () {
        var self = this;
        let tempArray = [];
        Array.from(this.fileInputRef.current.files).forEach(file => {
            
            let originalname = file.name.substring(0, file.name.lastIndexOf('.'));
            let extension = file.name.substring((file.name.lastIndexOf('.') + 1));

            if (extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "pdf") {
                let unique_id = uuid();
                let s3filename = "expense_attachment_" + this.state.vin + "_" + originalname;
                uploadS3(file, s3filename, extension, '/expense-attachments', unique_id, this.onUploadSuccess, this.onUploadFail);
                tempArray.push({Name: originalname, URL: "", Extension: extension, UUID: unique_id});
            }
        });
   
        if (this.state.vin !== '' && tempArray && (tempArray.length > 0) && (tempArray.length + this.state.invoices.length) <= 5) {
            var joined = this.state.invoices.concat(tempArray);
            this.setState({invoices: joined, edited: true});
        } else if ((tempArray.length + this.state.invoices.length) > 5) {
            let errors = this.state.errors;
            errors['pdfError'] = 'Sorry, a maximum of 5 files can be uploaded per expense.';
            this.setState({errors: errors});
        } else if (this.state.vin == '') {
            let errors = this.state.errors;
            errors['pdfError'] = 'Please select a vehicle before uploading any files.';
            this.setState({errors: errors});
        }
    }   

    getAttachmentURLs () {
        let tempArr = [];
        this.state.invoices.map((invoice) => {
            tempArr.push(invoice.URL);
        })
        return tempArr;
    }

    prepopulateForm() {
        var self = this;

        if (this.props.expense_id !== null) {
            axios.get('/ajax/expense/' + this.props.expense_id)
            .then(function (res) {

                let newcontent = {date: moment(res.data.date).format('MM-DD-YYYY'), merchant: res.data.merchant, totalcost: res.data.total_cost, netcost: res.data.net_cost, tax: res.data.tax, region: res.data.region, description: res.data.description}
                self.setState({
                    content: newcontent,
                    selectedVehicle: res.data.vehicle,
                    selectedBooking: res.data.linked_booking,
                    link_booking: res.data.linked_booking !== null,
                    link_user: res.data.linked_user == 1,
                    invoices: res.data.attachments, 
                    vehicle: res.data.vehicle.Make + ' ' + res.data.vehicle.Model, 
                    vin: res.data.vehicle.VIN, 
                    loading: false, 
                    vehicle_details: res.data.vehicle, 
                    line_items: res.data.line_items
                });
            })
            .catch(function(error) {
                if(error.response?.status == 401 || error.response?.status == 400){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    prepareForm(v_id) {
        var self = this;

        if (v_id !== '') {

            //retrieve the valid options for categories and regions/provinces
            axios.get('/ajax/expense/' + v_id + '/create')
            .then(function (res) {
                let cat_options = res.data.categories;
                cat_options.map((option, index) => {
                    option['active'] = false;
                });
                let newcontent = self.state.content;
                newcontent.region = "Ontario";
                if (!self.props.expense_id)
                    self.setState({province_options: res.data.province_options, category_options: cat_options, loading: false, content: newcontent});
                else {
                    self.setState({province_options: res.data.province_options, category_options: cat_options, content: newcontent});
                }
            }).catch(function(err) {
                if(error.response?.status == 401 || error.response?.status == 400){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else {
            //empty v_id, reset form
            this.setState({province_options: [], category_options: [], loading: false})
        }

    }

    submitExpense () {
        let invoices_uploaded = true;
        let invoice_has_error = false;

        this.state.invoices.forEach((invoice) => {
            if(invoice.error && invoice.error !== '') {
                invoice_has_error = true;
            }
            else if(invoice.URL == "") {
                invoices_uploaded = false;
            }
        });

        if(invoice_has_error) {
            showStatusMsg("Invalid invoice(s). Please remove them to continue.");
            return;
        }

        else if(!invoices_uploaded) {
            showStatusMsg("Invoice attachments still being uploaded, please wait for few seconds before submitting your request again.");
            return;
        }
        

        let newArr = this.state.line_items.map((item) => {
            let cat_id = 0;
            this.state.category_options.map((option, index) => {
                if (option.Name == item.category) {
                    cat_id = option.ID;
                    return;
                }
            })

            return ({
                category: item.category.ID ? item.category.ID : cat_id,
                description: item.Description,
                total_cost: Math.round((((parseFloat(item.Net_Cost)) + (parseFloat(item.Tax))) * 100)) / 100,
                net_cost: item.Net_Cost,
                tax: item.Tax
            })
        });

        var self = this;
        if (this.validateFields()) {
            axios.post('/ajax/expense/store/' + this.state.sh_id + "/" + this.state.v_id, {
                'id': this.state.v_id,
                'date': moment(this.state.content.date, 'MM-DD-YYYY').format('YYYY-MM-DD'),
                'merchant': this.state.content.merchant,
                'total_cost': this.getTotal('Total_Cost'),
                'net_cost': this.getTotal('Net_Cost'),
                'tax': this.getTotal('Tax'),
                'region': this.state.content.region,
                'linked_booking_id': this.state.selectedBooking?.BOOK_ID ? this.state.selectedBooking.BOOK_ID : null,
                'linked_user': this.state.link_user ? 1 : 0,
                'attachments': this.getAttachmentURLs(),
                'sh_id': this.state.sh_id,
                'line_item': newArr
            })
            .then(function(res) {
                //call a refresh on OL_Tab_VehicleExpenses
                self.props.refresh();
                self.props.closeOverlay();
            })
            .catch(function(error) {
                if(error.response?.status == 401 || error.response?.status == 400){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    getCategoryNameByID(id) {
        let temp = ''
        temp = this.state.category_options.map((category) => {
            if (category.ID == id)
                return category.Name;
        })
        return temp;
    }

    setLineItemValue(index, property, value) {
        let temp = this.state.line_items;
        if (property == 'delete') {
            temp.splice(index, 1);
            this.setState({line_items: temp})
        } else {
            temp[`${index}`][property] = value;
            this.setState(prevState => ({...prevState, temp}))
        }
    }

    addEmptyLineItem() {
        let temp = this.state.line_items;
        temp.push({
            category: '',
            Description: '',
            Net_Cost: '',
            Tax: '',
            Total_Cost: ''
        })
    }

    handleChange(val) {
        const { name, value, checked } = val.target;

        if (name == 'vehicle-search') {
            this.setState({vehicle: value, vehicleSearching: true});
            // this.validateFields();
            this.searchVehicles(value);
        } else if (name == 'booking-search') {
            this.setState({selectedBooking: null, link_booking_search: value});
            this.searchBookings(value);
        } else if (name == 'link-user') {
            this.setState({link_user: checked})
        }
    }

    getProfileName (booking) {
        let str = '';

        if (booking.First_Name !== null) {
            str += (booking.First_Name);
        }
        if (booking.Last_Name !== null) {
            str += (" " + booking.Last_Name);
        }
        if (booking.Title !== null) {
            str += (" - " + booking.Title);
        }
        if (booking.Company !== null) {
            if (booking.Title !== null) {
                str += (" at " + booking.Company);
            } else {
                str += (" - " + booking.Company);
            }
        }
        return str;
    };

    searchVehicles(value) {
        this.setState({noResults: false})
        var self = this;

        if (value.length >= 3) {
            axios.get('/ajax/expense?search_term=' + value)
            .then((res) => {
                if (res.data.vehicles.length > 0) {
                    self.setState({vehicleSearchResults: res.data.vehicles, showVehicleSearchResults: true, vehicleSearching: false});
                } else {
                    self.setState({vehicleSearchResults: [], showVehicleSearchResults: true, noResults: true, vehicleSearching: false})
                }
            })
            .catch(function(error) {
                self.setState({vehicleSearching: false})
                if(error.response?.status == 401 || error.response?.status == 400){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else if (value == '') {
            this.setState({vehicle: null, vin: '', v_id: ''});
            this.prepareForm('');
        }
    }

    searchBookings(value) {
        this.setState({noResults: false});

        let searchResults = [];

        if (value.length >= 1) {
            this.state.vehicle_bookings.map((booking)=> {
                if ((booking.Book_Type) 
                    && (booking.Start_Date && moment(booking.Start_Date).format('MMM DD, YYYY').toString().toUpperCase().includes(value.toUpperCase()) 
                    || (booking.End_Date && moment(booking.End_Date).format('MMM DD, YYYY').toString().toUpperCase().includes(value.toUpperCase())
                    || (((booking.First_Name ? booking.First_Name.toUpperCase() : "") + " " + (booking.Last_Name ? booking.Last_Name.toUpperCase() : "")).includes(value.toUpperCase()))
                    || (((booking.Release_To ? booking.Release_To.toUpperCase() : "") + " " + (booking.Vehicle_Usage ? booking.Vehicle_Usage.toUpperCase() : "")).includes(value.toUpperCase()))))) {
                        searchResults.push(booking);
                }
            });
        this.setState({bookingSearchResults: searchResults, showBookingSearchResults: true})
        } else if (value == '') {
            this.state.vehicle_bookings.map((booking)=> {
                if (booking.Book_Type)
                    searchResults.push(booking);        
            })
        this.setState({bookingSearchResults: searchResults, showBookingSearchResults: true});
        }
    }

    selectVehicleFromSearch(veh) {
        let self = this;

        axios.get('/ajax/vehicle/' + veh.V_ID)
        .then((result)=> {
            self.setState({
                vehicle_details: result.data, 
                vehicle_bookings: [
                    ...result.data.bookings.cancelled,
                    ...result.data.bookings.current,
                    ...result.data.bookings.past,
                    ...result.data.bookings.pending,
                    ...result.data.bookings.pending_return,
                    ...result.data.bookings.upcomming,
                ]
            });
        })
        .catch((err)=> {
            console.error(err);
        })
        let newErrors = this.state.errors;
        
        newErrors.vehicleError = "";
        newErrors.pdfError = "";

        this.setState({selectedVehicle: veh, showVehicleSearchResults: false, vehicle: veh.Year + " " + veh.Make + " " + veh.Model + " " + veh.Trim, sh_id: veh.SH_ID, vin: veh.VIN, v_id: veh.V_ID, errors: newErrors});
        this.prepareForm(veh.V_ID);
    }

    selectBookingFromSearch(booking) {
        this.setState({selectedBooking: booking, showBookingSearchResults: false});
        setTimeout(()=>{
            ReactTooltip.rebuild();
        },500)
    }

    updateExpense () {
        let invoices_uploaded = true;

        this.state.invoices.forEach((invoice) => {
            if(invoice.URL == "") {
                invoices_uploaded = false;
            }
        });

        if(!invoices_uploaded) {
            showStatusMsg("Invoice attachments still being uploaded, please wait for few seconds before submitting your request again.");
            return;
        }

        let newArr = this.state.line_items.map((item) => {
            let cat_id = 0;
            this.state.category_options.map((option, index) => {
                if (option.Name == item.category) {
                    cat_id = option.ID;
                    return;
                }
            })
            return ({
                category: item.category.ID? item.category.ID : cat_id,
                description: item.Description,
                total_cost: Math.round((((parseFloat(item.Net_Cost)) + (parseFloat(item.Tax))) * 100)) / 100,
                net_cost: item.Net_Cost,
                tax: item.Tax
            })
        });
        
        var self = this;
        if (this.validateFields()) {
            axios.post('/ajax/expense/' + this.props.expense_id + '/update', {
                'id': this.props.expense_id,
                'date': moment(this.state.content.date, 'MM-DD-YYYY').format('YYYY-MM-DD'),
                'merchant': this.state.content.merchant,
                'total_cost': this.getTotal('Total_Cost'),
                'net_cost': this.getTotal('Net_Cost'),
                'tax': this.getTotal('Tax'),
                'region': this.state.content.region,
                'linked_booking_id': this.state.selectedBooking?.BOOK_ID ? this.state.selectedBooking.BOOK_ID : null,
                'linked_user': this.state.link_user ? 1 : 0,
                'attachments': this.getAttachmentURLs(),
                'sh_id': this.state.sh_id,
                'line_item': newArr
            })
            .then(function(res) {
                self.props.refresh();
                self.props.closeOverlay();

            })
            .catch(function(error) {
                if(error.response?.status == 401 || error.response?.status == 400){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    sumStr(str){
        let strArr = str?.split(",");
        let sum = strArr.reduce(function(total, num){
          return parseFloat(total) + parseFloat(num);
        });
    
        return Number.parseFloat(sum).toFixed(2);
    }

    getTotal(type) {
        let sum = '';
        if (type == 'Total_Cost') {
            try {
                if (this.state.line_items.length >= 1) {
                    sum += this.state.line_items.map((item) => {
                        let inner_sum = 0;
                            if (!(isNaN(item['Net_Cost']) || item['Net_Cost'] == '' || item['Net_Cost'] == null))
                                inner_sum += parseFloat(item['Net_Cost']);
                            if (!(isNaN(item['Tax']) || item['Tax'] == '' || item['Tax'] == null))
                                inner_sum += parseFloat(item['Tax']);
                        return inner_sum;
                    })
                    return this.sumStr(sum);
                }
                else return '0.00';
            } catch (err) {
                // console.log(err);
            }
        }
        else {
            try {
                if (this.state.line_items.length >= 1) {
                    sum += this.state.line_items.map((item) => {
                        if (isNaN(item[type]) || item[type] == '' || item[type] == null)
                            return 0;
                        else {
                            return item[type];
                        }
                    })
                    return this.sumStr(sum);
                }
                else return '0.00';
            } catch (err) {
                // console.log(err);
            }
        }
    }

    openAttachment(URL) {
        if(URL)
        {
            window.open("https://digitalvms.s3.ca-central-1.amazonaws.com/expense-attachments/" + URL);
        }
        else
        {
            showStatusMsg("This attachment is still being uploaded.");
        }
    }

    render () {
        const activeIconStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue}
        
        return (
            this.state.loading ? 
                <div>
                    <LoadingIcon/>
                </div> 
            : <div className="main_overlay add_exp_overlay">
                <div className="card overflow" onClick={()=> {this.setState({showSearchResults: false})}} style={{marginBottom: 0}}>
                    <div style={{display: 'flex', flex: 1, flexDirection: 'row', padding: '24px 16px', justifyContent: 'center'}}> 
                        <Heading6 className="overlay_header_info_title_text" style={{display: 'flex', flex: 1, justifyContent: 'center', marginLeft: '28px'}}>
                            {this.props.mode == constants.add_expense_mode.add ? i18n.t("Add Expense") : i18n.t("Edit Expense")}
                        </Heading6>
                        <div style={{display: 'flex', justifySelf: 'flex-end', width: '28px', height: '28px', cursor: 'pointer', userSelect: 'none'}} onClick={()=> this.props.closeOverlay()}>
                            {XIconGrey()}
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <div className="add-exp-section">
                            <div id="vehicle_field" style={{display: 'flex', flexDirection: 'column', flex: 1, position: 'relative', display: 'inline-block'}}>
                                { !this.state.selectedVehicle ?
                                    <>
                                        <Input 
                                        leading_ic="Search"
                                        label={i18n.t("Vehicle")}
                                        ref={this.searchVehicleRef}
                                        required
                                        placeholder="Search by Year, Make, Model, or VIN" 
                                        value={this.state.vehicle} 
                                        name="vehicle-search"
                                        onChange={(val) => this.handleChange(val)} 
                                        style={{marginBottom: 0}}
                                        variant={this.state.noResults || this.state.errors.vehicleError ? 
                                            "error" : ""}
                                        message={this.state.errors.vehicleError}
                                        />
                                        {this.state.showVehicleSearchResults && this.state.vehicle && this.state.vehicle.length >= 3 ? 
                                        <ul className="list-action-dropdown add-expense" style={(this.state.noResults || this.state.vehicleSearching) ? {height: 58} : {}}>
                                            {
                                                ((this.state.vehicleSearchResults.length > 0 ) || (!this.state.noResults)) && (!this.state.vehicleSearching) ?
                                                    this.state.vehicleSearchResults.slice(0, 9).map((result) => (
                                                        <li 
                                                            style={{cursor: 'pointer', borderBottom: `solid 1px ${colours.primary.grey04}`}} 
                                                            onClick={()=>{this.selectVehicleFromSearch(result)}} 
                                                            tabIndex={this.state.showVehicleSearchResults ? 0 : -1}
                                                            role="button"
                                                            onKeyPress={()=>{this.selectVehicleFromSearch(result)}}
                                                        >
                                                            <VehicleResultCard vehicle={result} search_term={this.state.vehicle}/>
                                                        </li>
                                                    ))
                                                : this.state.vehicleSearching ? 
                                                <li style={{display: 'flex', flexDirection: 'row', flex: 1, justifyContent: 'center', alignItems: 'center', height: 40, marginLeft: 8, marginRight: 8, borderRadius: 8}}>
                                                    <Icon name="Refresh" size={24} style={{marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue}}/>
                                                    <P3Bold>{i18n.t('Loading vehicle details')}</P3Bold>
                                                </li>
                                                :
                                                <li style={{display: 'flex', flexDirection: 'row', flex: 1, justifyContent: 'center', alignItems: 'center', height: 40, marginLeft: 8, marginRight: 8, borderRadius: 8}}>
                                                    <Icon name="NoResults" size={24} style={{marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue}}/>
                                                    <P3Bold>{i18n.t('No results match your search')}</P3Bold>
                                                </li>
                                            }
                                            {}
                                        </ul> : null}
                                    </>
                                    :
                                    <div>
                                        <div style={{marginLeft: 16, marginBottom: 4, display: 'flex', flexDirection: 'row'}}>
                                            <InputLabel>{i18n.t('Vehicle')}</InputLabel>
                                            <div className="ds-input-required" style={{lineHeight: '16px'}}>*</div>
                                        </div>
                                        <SelectedVehicleCard 
                                            vehicle={this.state.selectedVehicle} 
                                            onClose={()=>{
                                                this.setState({selectedVehicle: null, vehicle: '', link_booking: false, selectedBooking: null, category_options: [], province_options: [], content: [], errors: []});
                                                setTimeout(()=>{
                                                    this.searchVehicleRef.current && this.searchVehicleRef.current.focus();
                                                }, 250)
                                            }}/>
                                    </div>
                                }
                            {this.state.selectedVehicle ?
                            <>
                                <div style={{marginTop: 24, marginBottom: 16, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                    <Toggle 
                                        defaultChecked={this.state.link_booking} 
                                        icons={false} 
                                        onChange={() => {
                                            this.searchBookings('');
                                            this.setState(prev => ({link_booking: !prev.link_booking}));
                                            setTimeout(()=>{
                                                this.searchBookingsRef.current && this.searchBookingsRef.current.focus();
                                            }, 250)
                                        }}/>
                                    <InputLabel style={{marginLeft: 8, marginRight: 4}}>{i18n.t('Link Expense to Booking')}</InputLabel>
                                    <div style={{display: 'flex'}} data-tooltip data-place="right" data-class="ds-light-tooltip" data-multiline data-tip={i18n.t("Linked expenses are <br> also tracked by booking <br> and will be seen on <br> the Booking Details page")}>
                                        <Icon name="Info" size={20} style={{color: colours.primary.grey02}}/>
                                    </div>
                                </div>
                                {this.state.link_booking ? 
                                    <div style={{display: 'flex', flexDirection: 'column', flex: 1, display: 'block', position: 'relative'}}>
                                        <>
                                            <div style={{display: 'flex', flexDirection: 'row', flex: 1}}>
                                                <Input
                                                    label={i18n.t("Booking")}
                                                    required
                                                    autoComplete="off"
                                                    ref={this.searchBookingsRef}
                                                    name="booking-search"
                                                    placeholder={i18n.t("Search by Date or User Name")}
                                                    leading_ic={this.state.selectedBooking ? "" : "Search"}
                                                    trailing_ic={this.state.selectedBooking ? "Close" : ""}
                                                    trailing_ic_onClick={()=>{this.setState({selectedBooking: null, link_booking_search: ''})}}
                                                    value={this.state.selectedBooking ? 
                                                        (moment(this.state.selectedBooking.Start_Date).format('MMM DD, YYYY') + ' - ' + moment(this.state.selectedBooking.End_Date).format('MMM DD, YYYY'))
                                                        : this.state.link_booking_search}
                                                    onChange={this.handleChange}
                                                    onFocus={()=>{this.setState({showBookingSearchResults: true})}}
                                                    onBlur={()=>{setTimeout(()=>{this.setState({showBookingSearchResults: false})}, 150)}}
                                                />
                                            </div>
                                            {this.state.showBookingSearchResults ? 
                                                <ul className="list-action-dropdown add-expense" style={{height: 310}}>
                                                    {
                                                        (this.state.bookingSearchResults.length > 0 ) ?
                                                            this.state.bookingSearchResults.slice(0, 9).map((result) => (
                                                                <li
                                                                    className="addexp-booking-search-result-li"
                                                                    style={{cursor: 'pointer', borderBottom: `solid 1px ${colours.primary.grey04}`}} 
                                                                    onClick={()=>{this.selectBookingFromSearch(result)}} 
                                                                    onKeyPress={()=>{this.selectBookingFromSearch(result)}}
                                                                    tabIndex={this.state.showBookingSearchResults ? 0 : -1}
                                                                    role="button"
                                                                >
                                                                    <BookingResultCard booking={result} search_term={this.state.link_booking_search}/>
                                                                </li>
                                                            ))
                                                        :
                                                        <li style={{display: 'flex', flexDirection: 'row', flex: 1, justifyContent: 'center', alignItems: 'center', height: 40, marginLeft: 8, marginRight: 8, borderRadius: 8}}>
                                                            <Icon name="NoResults" size={24} style={{marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue}}/>
                                                            <P3Bold>{i18n.t('No results match your search')}</P3Bold>
                                                        </li>
                                                    }
                                                </ul> 
                                            : null }
                                        </>
                                        {this.state.selectedBooking ?
                                        <>
                                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 4}}>
                                                <InputLabel style={{marginLeft: 16, marginRight: 4}}>{i18n.t('Link Expense to User')}</InputLabel>
                                                <div style={{display: 'flex'}} data-tooltip data-place="right" data-class="ds-light-tooltip" data-multiline data-tip={i18n.t("Linked expenses are <br> also tracked by user <br> and will be seen on <br> the User Details page")}>
                                                    <Icon name="Info" size={16} style={{color: colours.primary.grey02}}/>
                                                </div>
                                            </div>
                                            <div style={{height: 40, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                <div style={{width: 40, justifyContent: 'center', marginTop: 'auto', display: 'flex', flexDirection: 'row'}}>
                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.link_user}
                                                        name="link-user"
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <div style={{display: 'flex', flex: 1, border: `solid 1px ${colours.primary.grey02}`, background: colours.primary.grey05, borderRadius: 8}}>
                                                    <div style={{display: 'flex', flex: 1, padding: '8px 12px'}}>
                                                        {
                                                            this.state.selectedBooking.profile ?
                                                                <P3 style={{fontSize: 14, lineHeight: '24px'}}>
                                                                    {this.getProfileName(this.state.selectedBooking.profile)}
                                                                </P3>
                                                            : null
                                                        }
                                                    </div>
                                                    { this.state.selectedBooking.profile && this.state.selectedBooking.profile.sh_vmh_access && this.state.selectedBooking.profile.sh_vmh_access.length > 0 ?
                                                        <div style={{maxHeight: 36, display: 'flex', justifySelf: 'flex-end', alignItems: 'center', padding: '0px 12px', marginTop: 4}}>
                                                            <Stars type={"Profile"} ID={this.state.selectedBooking.profile.ID} star={(this.state.selectedBooking.profile.sh_vmh_access[0].tier.Rank)}/>
                                                        </div>
                                                    : null}
                                                </div>
                                            </div>
                                        </>
                                        : null }
                                    </div>
                                    
                                : null}
                            </> : null }
                            </div>
                        </div>
                        <div style={{borderBottom: 'solid 1px lightgrey', marginLeft: 15, marginRight: 15, marginBottom: 15}}></div>
                        <div className="add-exp-section" style={{flexDirection: this.state.windowWidth <= 768 ? 'column' : 'row'}}>
                            <div id="date_field" className={this.state.windowWidth <= 768 ? "" : "mr-20"} style={{display: 'flex', flexDirection: 'column', marginBottom: 0, width: this.state.windowWidth <= 768 ? undefined : '180px', minWidth: '180px'}}>
                                <Input
                                    datepicker
                                    value={this.state.content.date}
                                    name="date_of_expense"
                                    onChange={(val) => {
                                        if (moment(val.target.value, 'MM-DD-YYYY').isValid() &&  moment(val.target.value, 'MM-DD-YYYY').isAfter(moment())) {
                                            let temp = this.state.errors;
                                            temp.dateError = 'Post-dated';
                                            this.setState({ errors: temp, content: { ...this.state.content, date: val.target.value}});
                                        } else {
                                            let temp = this.state.errors;
                                            temp.dateError = '';
                                            this.setState({ content: { ...this.state.content, date: val.target.value}});
                                        }   
                                    }}
                                    label={i18n.t("Date of Expense")}
                                    id="new_expense_date"
                                    disabled={false}
                                    placeholder="MM-DD-YYYY"
                                    onBlur={(val)=> {

                                        if (!moment(val.target.value, 'MM-DD-YYYY').isValid()) {
                                            let temp = this.state.errors;
                                            temp.dateError = 'Invalid Date';
                                            this.setState({ errors: temp, content: { ...this.state.content, date: val.target.value}});
                                        }
                                    }}
                                    required
                                    trailing_ic="Calendar" 
                                    trailing_ic_style={{color: colours.primary.grey03}}
                                    variant={this.state.errors.dateError ? "error" : ""}
                                    message={this.state.errors.dateError}
                                />
                            </div>
                            <div className={this.state.windowWidth <= 768 ? "" : "mr-20"} style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                                <Input 
                                    type="text"
                                    required
                                    label={i18n.t("Merchant")}
                                    value={this.state.content.merchant} 
                                    placeholder="Name of the Merchant" 
                                    onChange={(val) => this.setState({ content: { ...this.state.content, merchant: val.target.value}})}
                                    variant={this.state.errors.merchantError ? "error" : ""}
                                    message={this.state.errors.merchantError} 
                                />
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', width: this.state.windowWidth <= 768 ? undefined : '180px', minWidth: '180px'}}>
                                <Input 
                                    dropdown
                                    required
                                    type="text"
                                    label={i18n.t("Region")}
                                    placeholder={this.state.province_options.length < 1 ? "Select Vehicle" : 'Select Region'}
                                    value={this.state.content.region} 
                                    onChange={(e) => this.setState({ content: { ...this.state.content, region: e.currentTarget.dataset.id}, regionError: ''})} 
                                    style={{height: 38, maxHeight: 38}} 
                                    disabled={this.state.province_options.length < 1}
                                    dropdownContainerProps={{style: {maxHeight: '350px', overflowY: 'auto'}}}
                                    variant={this.state.errors.regionError ? "error" : ""}
                                    message={this.state.errors.regionError} 
                                >
                                    {this.state.province_options.map((province) => (
                                        <DropdownItem value={province[0]} label={province[1]} />
                                    ))}
                                </Input>
                            </div>
                        </div>
                        <div className="add-exp-section" style={{flexWrap: 'unset'}}>
                            <div className="line-item-container" style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                                <div style={{marginLeft: 16, marginBottom: 4, display: 'flex', flexDirection: 'row'}}>
                                    <InputLabel>{i18n.t('Line Items')}</InputLabel>
                                    <div className="ds-input-required" style={{lineHeight: '16px'}}>*</div>
                                </div>
                                <div style={{width: '100%'}}>
                                    <div style={{display: 'flex', flex: 16, flexDirection: 'row', marginBottom: 8, paddingLeft: 16, marginTop: 4}}>
                                        <div style={{display: 'flex', flex: 4, minWidth: '150px'}}>
                                            <CaptionSmall className="add-exp-center">{i18n.t('Category')}</CaptionSmall>
                                        </div>
                                        <div style={{display: 'flex', flex: 5, minWidth: '200px'}}>
                                            <CaptionSmall className="add-exp-center">{i18n.t('Description')}</CaptionSmall>
                                        </div>
                                        <div style={{display: 'flex', flex: 2, minWidth: '75px'}}>
                                            <CaptionSmall className="add-exp-center">{i18n.t('Net Cost')}</CaptionSmall>
                                        </div>
                                        <div style={{display: 'flex', flex: 2, minWidth: '75px'}}>
                                            <CaptionSmall className="add-exp-center">{i18n.t('Tax')}</CaptionSmall>
                                        </div>
                                        <div style={{display: 'flex', flex: 2, minWidth: '75px'}}>
                                            <CaptionSmall className="add-exp-center">{i18n.t('Total Cost')}</CaptionSmall>
                                        </div>
                                        <div style={{display: 'flex', flex: 1, minWidth: '30px', maxWidth: '30px', paddingLeft: 4}}>
                                            <CaptionSmall className="add-exp-center"></CaptionSmall>
                                        </div>
                                    </div>
                                </div>
                                {this.state.line_items.map((item, index) => {
                                    return (
                                        <div style={{display: 'flex', flex: 16, marginBottom: 8}}>
                                            <div className="tr-line-item" key={index} style={{display: 'flex', flexDirection: 'row', flex: 15, overflowX: 'auto', overflow: 'visible'}}>
                                                <div label="Category" style={{display: 'flex', flex: 4, overflow: 'visible', minWidth: '150px'}}>
                                                    <Input
                                                        dropdown
                                                        value={item.category.Name ? item.category.Name : item.category}
                                                        placeholder={this.state.category_options.length < 1 ? "Select Vehicle" : "Select Category"}
                                                        disabled={this.state.category_options.length < 1} 
                                                        onChange={(val) => {
                                                            this.setLineItemValue(index, 'category', val.currentTarget.dataset.id);
                                                        }} 
                                                        style={{height: 38, maxHeight: 38}}
                                                        inputclass="add-exp-lineitem-input first"
                                                    >
                                                        {this.state.category_options.map((category) => (
                                                            <DropdownItem value={category.Name} label={category.Name}/>
                                                        ))}
                                                    </Input>
                                                </div>
                                                <div label="Description" className="add-exp-section-value" style={{display: 'flex', flex: 5, minWidth: '200px'}}>
                                                    <Input 
                                                        value={item.Description} 
                                                        placeholder="Describe the expense" 
                                                        onChange={(val) => {
                                                            this.setLineItemValue(index, 'Description', val.target.value);
                                                        }}
                                                        inputclass="add-exp-lineitem-input"
                                                    />
                                                </div>
                                                <div label="Net Cost" className="add-exp-section-value " style={{display: 'flex', flex: 2, minWidth: '75px'}}>
                                                    <Input 
                                                        value={item.Net_Cost} 
                                                        placeholder="$0.00" 
                                                        style={{textAlign: 'end', minWidth: '75px'}} 
                                                        onChange={(val) => {
                                                            this.setLineItemValue(index, 'Net_Cost', val.target.value);
                                                        }}
                                                        inputclass="add-exp-lineitem-input align-right"
                                                    />
                                                </div>
                                                <div label="Tax" className="add-exp-section-value " style={{display: 'flex', flex: 2, minWidth: '75px'}}>
                                                    <Input 
                                                        value={item.Tax} 
                                                        placeholder="$0.00" 
                                                        style={{textAlign: 'end', minWidth: '75px'}} 
                                                        onChange={(val) => {
                                                            this.setLineItemValue(index, 'Tax', val.target.value);
                                                        }}
                                                        inputclass="add-exp-lineitem-input align-right"
                                                    />
                                                </div>
                                                <div label="Total Cost" className="add-exp-section-value " style={{display: 'flex', flex: 2, minWidth: '75px'}}>
                                                    <Input 
                                                        value={isNaN(parseFloat(item.Net_Cost) + parseFloat(item.Tax)) ? "$0.00" : new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format((parseFloat(item.Net_Cost) + parseFloat(item.Tax)))} 
                                                        readOnly
                                                        style={{textAlign: 'end', minWidth: '75px'}} 
                                                        onChange={(val) => {
                                                            this.setLineItemValue(index, 'Total_Cost', val.target.value);
                                                        }}
                                                        inputclass="add-exp-lineitem-input last align-right"
                                                    />
                                                </div>
                                            </div>
                                            <div label="Delete" className="add-exp-section-value remove-button" style={{display: 'flex', flex: 1, alignItems: 'center', height: '48px', paddingLeft: 4, minWidth: '30px', maxWidth: '30px'}}>
                                                <div style={{height: '28px', width: '28px', cursor: 'pointer', userSelect: 'none' }} onClick={()=> {
                                                    this.setLineItemValue(index, 'delete');
                                                }}>
                                                        <abbr title="Delete Line Item">{XIconGrey()}</abbr>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                <div style={{display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center', marginTop: 8, marginBottom: 32}}>
                                    <Button leading_ic="Plus" secondary label="Add Item" onClick={()=> {this.addEmptyLineItem()}}/>
                                </div>
                                <div style={{borderTop: 'solid 1px #eeeeee', display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 16, paddingTop: 8}}>
                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 15}}>
                                        <div label="Category" style={{display: 'flex', flex: 4, overflow: 'visible', alignItems: 'center', minWidth: '150px'}}>
                                            <CaptionLarge label="" className="add-exp-section-value total add-exp-center" style={{lineHeight: '24px'}}>
                                                {i18n.t('Line Items')}:
                                            </CaptionLarge>
                                            <P2Bold label="" className="add-exp-section-value total add-exp-center" style={{marginLeft: 8}}>
                                                {this.state.line_items.length}
                                            </P2Bold>
                                        </div>
                                        <div label="Description" className="add-exp-section-value" style={{display: 'flex', flex: 5, minWidth: '200px'}}>
                                            <P2Bold label="" className="add-exp-section-value add-exp-center" style={{maxWidth: '400px'}}>
                                            </P2Bold>
                                        </div>
                                        <div label="Net Cost" className="add-exp-section-value " style={{display: 'flex', flex: 2, minWidth: '75px'}}>
                                            <P2Bold label="Net Cost" className="add-exp-section-value total add-exp-right mr-8" style={{width: '80px', maxWidth: '80px', paddingRight: '8px', textAlign: 'end'}}>
                                                ${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format((parseFloat(this.getTotal('Net_Cost'))))}
                                            </P2Bold>
                                        </div>
                                        <div style={{display: 'flex', flex: 2, minWidth: '75px'}}>
                                            <P2Bold label="Tax" className="add-exp-section-value total add-exp-right mr-8" style={{width: '80px', maxWidth: '80px', paddingRight: '8px', textAlign: 'end'}}>
                                                ${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format((parseFloat(this.getTotal('Tax'))))}
                                            </P2Bold>
                                        </div>
                                        <div style={{display: 'flex', flex: 2, minWidth: '75px'}}>
                                            <P2Bold label="Total Cost" className="add-exp-section-value total add-exp-right mr-8" style={{width: '80px', maxWidth: '80px', paddingRight: '8px', textAlign: 'end'}}>
                                                ${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format((parseFloat(this.getTotal('Total_Cost'))))}
                                            </P2Bold>
                                        </div>
                                    </div>
                                    <div style={{display: 'flex', flex: 1, minWidth: '30px', maxWidth: '30px', paddingLeft: 4}}>
                                        <P2Bold style={{display: 'inline-block', width: '30px', maxWidth: '30px'}} width="30px">
                                            <div></div>
                                        </P2Bold>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="add-exp-section" style={{flexDirection: 'column'}}>
                                <div style={{marginLeft: 16, marginBottom: 4, display: 'flex', flexDirection: 'row'}}>
                                    <InputLabel>{i18n.t('Invoices')}</InputLabel>
                                </div>
                                <div className={`dropbox ${(this.state.dragging && this.state.selectedVehicle) ? "active" : "inactive"}`} style={{display: 'inline-flex', position: 'relative', width: '100%', justifyContent: 'center', marginBottom: 5}} ref={this.dropRef}>
                                    <label style={{width: '100%', display: 'flex', flexDirection: 'column', maxHeight: '120px', padding: '24px 16px', flex: 1, justifyContent: 'center', alignItems: 'center', cursor: 'pointer', pointerEvents: 'all'}}>
                                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                            { this.state.selectedVehicle ? <Icon name="Attach" size={24} style={activeIconStyle}/> : null }
                                            <P2Bold style={{color: colours.primary.grey01, lineHeight: '24px', marginLeft: 10}}>{this.state.selectedVehicle ? i18n.t('Add File or Drop Invoice Here') : i18n.t('Please Select a vehicle')}</P2Bold>
                                        </div>
                                        { this.state.selectedVehicle ?
                                            <>
                                                <P3 style={{color: colours.primary.grey02, marginTop: 4}}>{i18n.t('Supports: PDF, JPG & PNG')}</P3>
                                                <P3 style={{color: colours.primary.grey02, marginTop: 4}}>{i18n.t('Max file size: 10MB')}</P3>
                                            </> : null 
                                        }
                                        <input type="file" style={{display: 'none'}} disabled={!this.state.selectedVehicle} onChange={this.handleUpload} accept="image/png, image/jpeg, .jpg, .pdf" multiple ref={this.fileInputRef} />
                                    </label>
                                </div>
                            
                                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                                    {this.state.invoices.length > 0 ? this.state.invoices.map((invoice, index) => (
                                        <div className={"dropbox-invoice-item-container" + (invoice.error ? " error" : '')} key={"invoice_" + invoice.UUID + (invoice.URL == "" ? "1" : "0")}>
                                            <div style={{display: 'flex', justifySelf: 'flex-start', width: '24px', height: '24px', marginRight: 16}}>
                                                <Icon name="File" size={24} style={invoice.error ? {color: colours.accent.error_red} : {color: colours.primary.blue}}/>
                                            </div>
                                            <div className="dropbox-invoice-item-name" onClick={()=> this.openAttachment(invoice.URL)}>
                                                <P2 style={{lineHeight: '24px', fontWeight: 'normal'}}>
                                                    {invoice.Name}
                                                </P2>
                                                {
                                                    invoice.error ? 
                                                    <P3 style={{fontWeight: 'normal', color: colours.primary.grey02}}>
                                                        {invoice.error}
                                                    </P3> : null
                                                }
                                            </div>
                                            <div className="dropbox-invoice-item-trash" onClick={()=> {this.removePdf(index)}}>
                                                <Icon name="Trash" size={24}/>
                                            </div>
                                            <div style={{display: 'flex', justifySelf: 'flex-end', width: '24px', height: '24px', marginRight: 8}}>
                                                { invoice.error ? 
                                                    <Icon name="Close" size={24} style={{backgroundColor: colours.accent.error_red, borderRadius: '8px', color: '#ffffff'}}/>
                                                    : <Icon name="Check" size={24} style={{backgroundColor: colours.accent.validate_green, borderRadius: '8px', color: '#ffffff'}}/>
                                                }
                                            </div>
                                        </div>
                                    )) : null}
                                    <div className="add-exp-error">
                                        {this.state.errors.pdfError}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{display: 'flex', flex: 1, marginTop: 14, paddingBottom: 24, justifyContent: 'center'}}>
                        <div style={{width: 172, marginRight: 24}}>
                            <Button large secondary label={i18n.t('Cancel')} onClick={() => {this.props.closeOverlay()}} containerProps={{style: {display: 'block'}}}/>
                        </div>
                        <div style={{width: 172}}>
                        { this.props.mode == constants.add_expense_mode.edit ?
                            <Button large primary label={i18n.t('Save')} onClick={() => {this.updateExpense()}} containerProps={{style: {display: 'block'}}}/>
                            : <Button large primary label={i18n.t('Add')} onClick={() => {this.submitExpense()}} containerProps={{style: {display: 'block'}}}/>  
                        }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings,
    data: store.data
})

export default connect(mapStateToProps)(ExpenseOverlay)